import { render, staticRenderFns } from "./ViewCampaign.vue?vue&type=template&id=f504fe10&scoped=true&"
import script from "./ViewCampaign.vue?vue&type=script&lang=js&"
export * from "./ViewCampaign.vue?vue&type=script&lang=js&"
import style0 from "./ViewCampaign.vue?vue&type=style&index=0&id=f504fe10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f504fe10",
  null
  
)

export default component.exports